import React, { useState } from "react";
import { FaEye } from "react-icons/fa6";
import { iconsDocs } from "../../services/icones-fichiers";
import { isImageFormat } from "../../services/normalizeContenu";
import FilePreviewModal from "./FilePreviewModal";
import "../../assets/css/component-media-gallery.css";

const MAX_VISIBLE = 4;
const VIDEO_FORMATS = ["mp4", "mov", "avi", "webm"];

export default function FileGrid({ files, onOpenGallery }) {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(0);

  if (!files || files.length === 0) return null;

  const visibleFiles = files.slice(0, MAX_VISIBLE);
  const extraCount = files.length - MAX_VISIBLE;

  const gridClass =
    files.length === 1 ? "file-grid file-grid--single" : "file-grid file-grid--multi";

  const openPreview = (idx) => {
    setPreviewIndex(idx);
    setPreviewOpen(true);
  };

  const handleItemClick = (file, idx) => {
    const isImage = isImageFormat(file.format);
    const isVideo = VIDEO_FORMATS.includes(file.format?.toLowerCase());

    if ((isImage || isVideo) && onOpenGallery) {
      onOpenGallery(file.fileUrl);
    } else {
      openPreview(idx);
    }
  };

  return (
    <>
      {extraCount > 0 && (
        <div className="file-grid-extra-badge" onClick={() => openPreview(0)}>
          +{extraCount} fichier{extraCount > 1 ? "s" : ""}
        </div>
      )}
      <div className={gridClass}>
        {visibleFiles.map((file, idx) => {
          const isImage = isImageFormat(file.format);

          if (isImage) {
            return (
              <div
                key={idx}
                className="file-grid-item my-msg-img-container"
                onClick={() => handleItemClick(file, idx)}
              >
                <img src={file.fileUrl} className="my-msg-img" alt={file.nom} />
                <div className="my-msg-img-overlay">
                  <FaEye />
                </div>
              </div>
            );
          }

          const ext = file.format?.toLowerCase();
          const iconData = iconsDocs.find((icon) => icon.extension === ext);
          const icon = iconData ? iconData.icon : iconsDocs[iconsDocs.length - 1].icon;

          return (
            <div
              key={idx}
              className="file-grid-item file-grid-doc"
              onClick={() => handleItemClick(file, idx)}
            >
              <div className="tyn-media tyn-size-lg text-bg-light">{icon}</div>
              <div className="file-grid-doc-info">
                <div className="name">{file.nom}</div>
                <div className="meta">{file.taille}</div>
              </div>
            </div>
          );
        })}
      </div>

      <FilePreviewModal
        files={files}
        initialIndex={previewIndex}
        isOpen={previewOpen}
        onClose={() => setPreviewOpen(false)}
      />
    </>
  );
}
